import StickyBar from './sticky-bar';

export default StickyBar;
